

const SERVICES = {
  dashboard: {
    title: 'navbar.Tree.Dashboard.Title',
    link: '/',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Dashboard.Options.YourDashboard',
        link: '/',
      },
    },
    isActive: (currentPath) => {
      return currentPath === '/' || currentPath.startsWith('/dashboard');
    },
  },
  caregiver: {
    title: 'navbar.Tree.Caregiver.Title',
    link: '/caregiver',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Caregiver.Options.New',
        link: '/caregiver/new',
      },
      TeamDashboard: {
        title: 'navbar.Tree.Caregiver.Options.List',
        link: '/caregiver',
      },
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/caregiver');
    },
  },
  client: {
    title: 'navbar.Tree.Client.Title',
    link: '/client',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Client.Options.New',
        link: '/client/new',
      },
      TeamDashboard: {
        title: 'navbar.Tree.Client.Options.List',
        link: '/client',
      },
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/client') && !currentPath.startsWith('/client_lead');
    },
  },
  schedule: {
    title: 'navbar.Tree.Schedule.Title',
    link: '/schedule/client',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Schedule.Options.Client',
        link: '/schedule/client',
      },
      TeamDashboard: {
        title: 'navbar.Tree.Schedule.Options.Caregiver',
        link: '/schedule/caregiver',
      },
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/schedule');
    },
  },
  user: {
    title: 'navbar.Tree.Users.Title',
    link: '/admin/user',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Users.Options.New',
        link: '/admin/user/new',
      },
      TeamDashboard: {
        title: 'navbar.Tree.Users.Options.List',
        link: '/admin/user',
      },
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/admin/user');
    },
  },
};

export default SERVICES;
